import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Box, Button } from "@mui/material";
import { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from '@mui/icons-material/Add';

const EmailTemplate = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [rows] = useState([
    {
      id: 1,
      name: "Welcome Email",
      title: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      type: "welcome_email",
      date: "01-Sept-2025"
    },
    {
      id: 2,
      name: "OTP",
      title: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      type: "otp_verification",
      date: "01-Sept-2025"
    },
    {
      id: 3,
      name: "Password Reset",
      title: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      type: "reset_password",
      date: "01-Sept-2025"
    }
  ]);

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </Box>
        </div>
        <div className="right_s">
          <Button className="btn btn_primary" onClick={() => navigate("/manage-system-settings/add-email-template")}><AddIcon /> Add Email Template</Button>
        </div>
      </div>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow hover>
              <TableCell>Template Name</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Event Type</TableCell>
              <TableCell>Date Created</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell className="max_c2">{row.title}</TableCell>
                <TableCell>{row.type}</TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell><SwitchToggle /></TableCell>
                <TableCell>
                  <div className="table_actions v2">
                    <IconButton onClick={() => navigate("/manage-system-settings/add-email-template")}>
                      <img src="/static/images/edit2_icon.svg" alt="" />
                    </IconButton>
                    <IconButton>
                      <img src="/static/images/trash2_icon.svg" alt="" />
                    </IconButton>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default EmailTemplate;
